module.exports = __webpack_public_path__ + "static/img/badge_shop_rakuten.4f63610.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/badge_shop_rakuten.png
// module id = gNPi
// module chunks = 1